import React from 'react';

import Table from '../../components/common/Table';
import { MemberTypeDTO } from '../../services/apiClient';
import { convertToUserTime } from '../../utils/dateUtils/convertToUserTime';
import { renderBooleanBadge } from '../../utils/displayUtils';

interface MemberTypeTableProps {
  data: MemberTypeDTO[];
  handleEdit: (row: MemberTypeDTO) => void;
  handleDelete: (row: MemberTypeDTO) => void;
  currentPage: number;
  totalPages: number;
  setCurrentPage: (page: number) => void;
  pageSize: number;
  setPageSize: (size: number) => void;
  isLoading: boolean;
}

const MemberTypeTable: React.FC<MemberTypeTableProps> = ({
  data,
  handleEdit,
  handleDelete,
  currentPage,
  totalPages,
  setCurrentPage,
  pageSize,
  setPageSize,
  isLoading,
}) => (
  <Table
    columns={[
      {
        label: 'Name',
        key: 'name',
      },

      {
        label: 'Description',
        key: 'description',
      },

      {
        label: 'Is Active',
        key: 'isActive',
        render: (row: MemberTypeDTO) =>
          renderBooleanBadge(row.isActive ?? false),
      },

      {
        label: 'Display Order',
        key: 'displayOrder',
      },

      {
        label: 'Added',
        key: 'createdUtc',
        format: (value: Date) => convertToUserTime(value?.toString() ?? ''),
      },
    ]}
    data={data}
    actions={{
      onEdit: handleEdit,
      onDelete: handleDelete,
    }}
    currentPage={currentPage}
    totalPages={totalPages}
    onPageChange={setCurrentPage}
    pageSize={pageSize}
    onPageSizeChange={setPageSize}
    isLoading={isLoading}
  />
);

export default MemberTypeTable;
